var _rect, _g, _g2, _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 20,
    rx: 2.5,
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.38378 16.2243C3.15914 16.2243 2.97944 16.0371 3.0019 15.8125C3.21156 12.9296 5.61517 10.6533 8.55044 10.6533C11.4857 10.6533 13.8893 12.9296 14.099 15.8125C14.114 16.0371 13.9343 16.2243 13.7171 16.2243H3.38378Z",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.55035 10.6459C10.1094 10.6459 11.3733 9.382 11.3733 7.82294C11.3733 6.26387 10.1094 5 8.55035 5C6.99128 5 5.72742 6.26387 5.72742 7.82294C5.72742 9.382 6.99128 10.6459 8.55035 10.6459Z",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 7.5,
    x2: 27,
    y2: 7.5,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 11.5,
    x2: 27,
    y2: 11.5,
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 15.5,
    x2: 27,
    y2: 15.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.d4e22504732781d841023a0097e1cd04.svg";
export { ForwardRef as ReactComponent };